import { Skeleton } from '@/components/ui/skeleton'

/** Skeleton for ConversionRateCard — stat cards grid */
export function ConversionRateCardSkeleton() {
    return (
        <div className="bg-white rounded-md border border-gray-200 p-4 h-full flex flex-col">
            <div className="flex items-center gap-2 mb-2">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-4 w-32" />
            </div>
            <div className="flex gap-2 mb-2">
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="flex-1 rounded-lg bg-gray-50 p-3">
                        <Skeleton className="h-3 w-16 mb-2" />
                        <Skeleton className="h-6 w-12" />
                    </div>
                ))}
            </div>
            <div className="flex-1 flex flex-col gap-2">
                <div className="flex gap-2 flex-1">
                    {[...Array(3)].map((_, i) => (
                        <div
                            key={i}
                            className="flex-1 rounded-lg bg-gray-50 p-3"
                        >
                            <Skeleton className="h-3 w-16 mb-2" />
                            <Skeleton className="h-6 w-12" />
                        </div>
                    ))}
                </div>
                <div className="flex gap-2 flex-1">
                    {[...Array(2)].map((_, i) => (
                        <div
                            key={i}
                            className="flex-1 rounded-lg bg-gray-50 p-3"
                        >
                            <Skeleton className="h-3 w-16 mb-2" />
                            <Skeleton className="h-6 w-12" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

/** Skeleton for funnel chart */
export function FunnelChartSkeleton() {
    return (
        <div className="bg-white rounded-md border border-gray-200 p-4 h-full flex flex-col">
            <div className="flex items-center gap-2 mb-4">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-4 w-40" />
            </div>
            <div className="flex-1 flex items-center justify-center">
                <div className="flex flex-col items-center gap-1 w-full">
                    {[100, 85, 65, 45, 30].map((w, i) => (
                        <Skeleton
                            key={i}
                            className="h-8 rounded"
                            style={{ width: `${w}%` }}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

/** Skeleton for line/bar chart (full-width) */
export function ChartSkeleton() {
    return (
        <div className="bg-white rounded-md border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-4 rounded" />
                    <Skeleton className="h-4 w-32" />
                </div>
                <div className="flex gap-1">
                    {[...Array(3)].map((_, i) => (
                        <Skeleton key={i} className="h-7 w-14 rounded-md" />
                    ))}
                </div>
            </div>
            <div className="flex items-end gap-1 h-[300px] pt-4">
                {[...Array(12)].map((_, i) => (
                    <Skeleton
                        key={i}
                        className="flex-1 rounded-t"
                        style={{
                            height: `${30 + Math.random() * 60}%`,
                        }}
                    />
                ))}
            </div>
        </div>
    )
}

/** Skeleton for half-width pie/bar chart */
export function HalfChartSkeleton() {
    return (
        <div className="bg-white rounded-md border border-gray-200 p-4">
            <div className="flex items-center gap-2 mb-4">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-4 w-36" />
            </div>
            <div className="flex items-end gap-1 h-[250px] pt-4">
                {[...Array(6)].map((_, i) => (
                    <Skeleton
                        key={i}
                        className="flex-1 rounded-t"
                        style={{
                            height: `${25 + Math.random() * 65}%`,
                        }}
                    />
                ))}
            </div>
        </div>
    )
}

/** Skeleton for data table sections */
export function TableSkeleton() {
    return (
        <div className="bg-white rounded-md border border-gray-200 p-4">
            <div className="flex items-center gap-2 mb-3">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-4 w-40" />
            </div>
            {/* Table header */}
            <div className="flex gap-2 mb-2">
                {[...Array(6)].map((_, i) => (
                    <Skeleton key={i} className="h-8 flex-1 rounded" />
                ))}
            </div>
            {/* Table rows */}
            {[...Array(5)].map((_, i) => (
                <div key={i} className="flex gap-2 mb-1.5">
                    {[...Array(6)].map((_, j) => (
                        <Skeleton key={j} className="h-7 flex-1 rounded" />
                    ))}
                </div>
            ))}
        </div>
    )
}

/** Skeleton for small revenue chart (sidebar) */
export function SmallChartSkeleton() {
    return (
        <div className="bg-white rounded-md border border-gray-200 p-4 h-full">
            <div className="flex items-center gap-2 mb-4">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-4 w-28" />
            </div>
            <div className="flex items-end gap-2 h-[200px] pt-4">
                {[...Array(4)].map((_, i) => (
                    <Skeleton
                        key={i}
                        className="flex-1 rounded-t"
                        style={{
                            height: `${30 + Math.random() * 60}%`,
                        }}
                    />
                ))}
            </div>
        </div>
    )
}
